import {createSvgIcon} from '../create-svg-icon';

export const ChevronRightIcon = createSvgIcon(
  <path d="M10 6 8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6-6-6z" />
, 'ChevronRightOutlined');
